import { createAsyncThunk } from '@reduxjs/toolkit';
import CompanySettingsServices from '@/services/CompanySettingsServices';

export const getPdfConfiguration = createAsyncThunk(
  'PdfConfiguration/getPdfConfiguration',
  async () => CompanySettingsServices.getCompanySettings()
);

export const updatePdfConfiguration = createAsyncThunk(
  'PdfConfiguration/updatePdfConfiguration',
  async (requestBody) =>
    CompanySettingsServices.updateCompanySettings(requestBody)
);
